import { SealsDto } from '@planning/app/api'
import { OrderSealsSubForm } from '@planning/pages/Order/V2/organisms/OrderSealsSubForm'
import { OrderSealsSubFormType } from '@planning/pages/Order/V2/stores/OrderSealsSubFormStore'
import { useFormStore } from '@tom-ui/utils'

interface IProps {
  hasSeals: boolean
  seals: SealsDto[]
  onChangeHasSeals?: (hasSeals: boolean) => void
  onChangeSeals?: (seals: SealsDto[]) => void
}

/**
 * @deprecated This component is provisional and should be removed once all forms
 * are migrated to formStores. Avoid using this component and opt for using the
 * formStore directly.
 */
export const ControlledContainerSealsWithTypes = ({
  hasSeals,
  seals,
  onChangeHasSeals,
  onChangeSeals,
}: IProps) => {
  const formStore = useFormStore<{ seals: OrderSealsSubFormType }>()

  return (
    <OrderSealsSubForm
      formStore={formStore}
      name='seals'
      initialValues={{
        hasSeals,
        seals,
      }}
      onChangeHasSeals={() => {
        const subformSealsData = formStore.data.seals
        const hasSeals = subformSealsData.hasSeals

        onChangeHasSeals?.(hasSeals)
      }}
      onChangeSeals={() => {
        const subformSealsData = formStore.data.seals
        const sealsDto = subformSealsData.seals ?? []

        onChangeSeals?.(sealsDto)
      }}
    />
  )
}
